import react, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import email from "../../shared/images/landing_page/email.png";
import BusinessReport from "../../shared/images/landing_page/business-report.png";
import Remainder from "../../shared/images/landing_page/remainder.png";
import Checked from "../../shared/images/landing_page/checked.png";
import Clock from "../../shared/images/landing_page/clock.png";
import Reconciliation from "../../shared/images/landing_page/reconciliation.png";
import Dashboard from "../../shared/images/landing_page/dashboard.png";
import mobileDashboard from "../../shared/images/landing_page/mobile_dashboard.png";

import { getHomeDomain, isMobileDevice } from "../../helpers/Utils";
import { ModalView } from "../common";
import Constants from "../../shared/constants/environmentConfig";
import Footer from "./footer";
import { newLeadData } from "../../actions";

const IS_MOBILE = isMobileDevice();

class Landing extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      name: "",
      phoneNumber: "",
      email: "",
      organizationName: "",
    };
  }

  async handleFormSubmit(event) {
    event.preventDefault();
    const { name, phoneNumber, email, organizationName } = this.state;
    const response = await this.props.newLeadData(
      name,
      email,
      phoneNumber,
      organizationName,
      "FEEBOARD"
    );
    if (response.success) {
      this.setState({ showModal: false });
    }
  }

  renderModal() {
    const { showModal, name, phoneNumber, email, organizationName } =
      this.state;
    const labelStyle = {
      display: "flex",
      justifyContent: "flex-start",
      width: IS_MOBILE ? 110 : 100,
    };
    const containerStyle = {
      display: "flex",
      margin: "10px 0px",
      maxWidth: IS_MOBILE ? 400 : 700,
      alignItems: "center",
    };

    return (
      <ModalView
        key={showModal}
        header={"Request a Demo"}
        isModalVisible={showModal}
        handleCloseModal={() => this.setState({ showModal: false })}
        width={IS_MOBILE ? 270 : 400}
      >
        <div style={{ padding: 30 }}>
          <form onSubmit={(event) => this.handleFormSubmit(event)}>
            <div style={containerStyle}>
              <label style={labelStyle} htmlFor="name">
                Name:
              </label>
              <input
                value={name}
                onChange={(event) => {
                  this.setState({ name: event.target.value });
                }}
                style={{
                  marginLeft: 10,
                  width: IS_MOBILE ? 100 : 200,
                }}
                type="text"
                name="name"
                id="name"
                maxLength="100"
                required
                aria-required="true"
              />
            </div>
            <div style={containerStyle}>
              <label style={labelStyle} htmlFor="phone_number">
                Phone Number:
              </label>
              <input
                value={phoneNumber}
                onChange={(event) => {
                  this.setState({ phoneNumber: event.target.value });
                }}
                style={{
                  marginLeft: 10,
                  width: IS_MOBILE ? 100 : 200,
                }}
                type="tel"
                name="phone_number"
                id="phone_number"
                pattern="[1-9]{1}[0-9]{9}"
                title="The phone number must be 10 digits"
                required
                aria-required="true"
              />
            </div>
            <div style={containerStyle}>
              <label style={labelStyle} htmlFor="phone_number">
                Email:
              </label>
              <input
                value={email}
                onChange={(event) => {
                  this.setState({ email: event.target.value });
                }}
                style={{
                  marginLeft: 10,
                  width: IS_MOBILE ? 100 : 200,
                }}
                type="email"
                name="email"
                id="email"
                required
                aria-required="true"
              />
            </div>
            <div style={containerStyle}>
              <label style={labelStyle} htmlFor="organnization_name">
                Organization Name:
              </label>
              <input
                value={organizationName}
                onChange={(event) => {
                  this.setState({ organizationName: event.target.value });
                }}
                style={{
                  marginLeft: 10,
                  width: IS_MOBILE ? 100 : 200,
                }}
                type="organization_name"
                name="organization_name"
                id="organization_name"
                aria-required="true"
              />
            </div>
            <div
              style={{
                display: "flex",
                marginTop: 20,
                marginLeft: IS_MOBILE ? 50 : 110,
              }}
            >
              <button
                type="submit"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: IS_MOBILE ? 100 : 222,
                  height: 35,
                  backgroundColor: "#152a53",
                  border: "none",
                  color: "#FFFFFF",
                  borderRadius: 4,
                  lineHeight: 0,
                  fontSize: 14,
                  cursor: "pointer",
                }}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </ModalView>
    );
  }

  renderScreen() {
    const customStyle = {
      display: "flex",
      width: !IS_MOBILE && 425,
      padding: "40px 20px",
    };
    return (
      <div>
        <div
          style={{
            boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.08)",
            backgroundColor: "white",
            height: 65,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "fixed",
            width: "100%",
            zIndex: 4,
            top: 0,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: IS_MOBILE ? 20 : 50,
            }}
          >
            <div
              style={{
                fontWeight: 800,
                backgroundColor: IS_MOBILE && "#f7f7f7",
                padding: 5,
                borderRadius: 4,
              }}
            >
              <span style={{ fontSize: 24 }}>
                <span style={{ color: "rgb(255,95,95)" }}>
                  {IS_MOBILE ? "F" : "FEE"}
                </span>
                <span style={{ color: "rgb(69,69,69)" }}>
                  {IS_MOBILE ? "B" : "BOARD"}
                </span>
              </span>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            {IS_MOBILE ? (
              <div style={{ marginRight: 20, fontSize: 35 }}>
                <a href="tel:08047187111">
                  <i className="fa fa-phone" style={{ color: "#152a53" }}></i>
                </a>
              </div>
            ) : (
              <div
                style={{
                  color: "rgb(69,69,69)",
                  fontSize: 18,
                  marginRight: IS_MOBILE ? 20 : 40,
                }}
              >
                080-471-87111
              </div>
            )}
            <div
              className="Button Secondary-Button"
              style={{ width: 100, marginRight: IS_MOBILE ? 20 : 40 }}
              onClick={() =>
                window.location.replace(`${Constants().accountsURL}/sign_in`)
              }
            >
              Sign In
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingTop: 100,
          }}
        >
          <div
            style={{
              textAlign: "center",
              fontSize: IS_MOBILE ? 25 : 45,
              marginTop: 90,
              fontWeight: 550,
              color: "#343737",
              width: IS_MOBILE ? window.innerWidth - 10 : 800,
              lineHeight: 1.5,
              letterSpacing: 0.5,
              maxWidth: 600,
            }}
          >
            Simple and efficient fee collection for your institute
          </div>
          <div
            className="Button Primary-Button"
            style={{
              marginTop: 50,
              width: 200,
              height: 45,
              fontSize: 17,
            }}
            onClick={() => this.setState({ showModal: true })}
          >
            REQUEST A DEMO
          </div>
          {!IS_MOBILE ? (
            <div
              className="container-background"
              style={{ marginTop: 50, padding: 20, backgroundColor: "#e7e7e7" }}
            >
              <img src={Dashboard} width="1100px" height="600px"></img>
            </div>
          ) : (
            <div
              className="container-background"
              style={{
                marginTop: 50,
                padding: 20,
                width: window.innerWidth - 60,
                maxWidth: 500,
              }}
            >
              <img src={mobileDashboard} width="100%"></img>
            </div>
          )}
          <div
            style={{
              display: "flex",
              flexFlow: "row wrap",
              justifyContent: "space-between",
              marginTop: 30,
              width: IS_MOBILE ? window.innerWidth : 1100,
              maxWidth: IS_MOBILE && 600,
            }}
          >
            <div style={customStyle}>
              <div style={{ paddingRight: 15 }}>
                <img width="70px" src={email}></img>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p className="landing-title">Dashboard and insights</p>
                <p className="landing-benefits">
                  Get thorough insights about your institute’s fee collection
                  and student dues.
                </p>
              </div>
            </div>
            <div style={customStyle}>
              <div style={{ paddingRight: 15 }}>
                <img width="70px" src={BusinessReport}></img>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p className="landing-title">Get daily email reports</p>
                <p className="landing-benefits">
                  Email report of the day’s fee collection broken down by
                  payment type, classroom, etc.
                </p>
              </div>
            </div>
            <div style={customStyle}>
              <div style={{ paddingRight: 15 }}>
                <img width="70px" src={Remainder}></img>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p className="landing-title">Fee reminders to parents</p>
                <p className="landing-benefits">
                  Instant SMS and email reminders to parents as the due date of
                  the payment approaches.
                </p>
              </div>
            </div>
            <div style={customStyle}>
              <div style={{ paddingRight: 15 }}>
                <img width="70px" src={Checked}></img>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p className="landing-title">Eliminate accounting errors</p>
                <p className="landing-benefits">
                  Ensure high productivity and efficiency of your accountant
                  through a simple experience.
                </p>
              </div>
            </div>
            <div style={customStyle}>
              <div style={{ paddingRight: 15 }}>
                <img width="70px" src={Clock}></img>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p className="landing-title">Payment history of each student</p>
                <p className="landing-benefits">
                  Track the payment history and dues of each student with a
                  single click.
                </p>
              </div>
            </div>
            <div style={customStyle}>
              <div style={{ paddingRight: 15 }}>
                <img width="70px" src={Reconciliation}></img>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p className="landing-title">Account reconciliation</p>
                <p className="landing-benefits">
                  Compare daily reports with fee collections to ensure accuracy.
                  Simple and Easy.
                </p>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderScreen()}
        {this.state.showModal && this.renderModal()}
      </div>
    );
  }
}

const mapStateToProps = ({}) => ({});

export default withRouter(connect(mapStateToProps, { newLeadData })(Landing));
